import React from 'react';
import './App.css';
import Header from './components/Header';
import ChargerList from './components/ChargerList';
import ChargerMap from './components/ChargerMap';
import LocationSelect from './components/LocationSelect';
import LocationSearch from './components/LocationSearch';

const axios = require('axios');

class App extends React.Component {
  state = {
    chargers: [],
    location: 'Leeds',
    distance: 1,
    isLoading: true,
    cityCoordinates: {
      coordinates: [53.799722, -1.549167],
      countrycode: 'GB',
    },
    defaultURL: 'https://api.openchargemap.io/v3/poi/?output=json&compact=true&verbose=false',
  }


  getChargerData = () => {
    const { cityCoordinates, distance, maxresults, defaultURL } = this.state;
    let queries = {
      params: {
        countrycode: cityCoordinates.countrycode,
        latitude: cityCoordinates.coordinates[0],
        longitude: cityCoordinates.coordinates[1],

        distance: distance || 1,
        maxresults: maxresults || 10,
      }
    }
    axios.get(defaultURL, queries)
      .then(({ data }) => {
        this.setState({ chargers: data, isLoading: false })
      })
  }

  componentDidMount() {
    console.log('mounting...');
    this.getChargerData(this.state.location)
  }

  updateInfo = (key, value) => {
    this.setState({ [key]: value }, this.getChargerData)
  }
  updateLocation = (newLocation) => {
    const { location, coordinates, countrycode } = newLocation;
    this.setState({
      location: location,
      cityCoordinates: {
        coordinates: coordinates,
        countrycode: countrycode,
      }
    }, this.getChargerData)
  }

  render() {
    if (this.state.isLoading) return <span> <img src='http://magventures.com/MAG2016/wp-content/uploads/2016/03/charging-battery.gif' alt="charging" /> </span>
    const { chargers, location, distance } = this.state;
    return (
      <div className="App" >
        <Header />
        <LocationSearch
          updateLocation={this.updateLocation} />
        <LocationSelect
          updateInfo={this.updateInfo}
        />
        <ChargerMap
          chargers={chargers}
          location={location}
          cityCoordinates={this.state.cityCoordinates}
          distance={distance}
        />
        <ChargerList chargers={chargers} />
      </div>
    )
  }
}

export default App;
